// OutboundShoe: Latest commit 061d83c on Apr 2, 2022

import React from "react";
import { TextField, NumberField } from "react-admin";

import {
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    "@media print": {
      display: "block",
      minWidth: "1200px",
      margin: "0",
      padding: "50px !important",
    },
  },
  break: {
    "@media print": {
      display: "block",
      pageBreakBefore: "auto",
    },
  },
  text: {
    "@media print": {
      color: "#000",
    },
  },
}));

const HeaderBlock = (props) => {
  return (
    <Grid container fullwidth spacing={3}>
      <Grid item xs={12} align="center">
        <Typography variant="h6" gutterBottom>
          {" "}
          OUTBOUND MANIFEST
        </Typography>
      </Grid>
      <Grid item xs={12} align="center">
        {" "}
        <Divider />{" "}
      </Grid>
    </Grid>
  );
};

const InfoBlock = ({ record, ...props }) => {
  const classes = useStyles();

  return (
    <Table style={{ width: "100%" }}>
      <TableBody>
        <TableRow>
          <TableCell style={{ textAlign: "center" }} className={classes.text}>
            <Typography variant="h6"> Shipment Date: </Typography>
            {new Date(
              record.outboundShipment.departureDateTime,
            ).toLocaleDateString()}{" "}
            <br />
          </TableCell>
          <TableCell style={{ textAlign: "center" }} className={classes.text}>
            <Typography variant="h6"> Pickup Number: </Typography>
            {record.outboundShipment.pickupNumber} <br />
          </TableCell>
          <TableCell style={{ textAlign: "center" }} className={classes.text}>
            <Typography variant="h6"> Carrier: </Typography>
            {record.outboundShipment.carrierName} <br />
          </TableCell>
          <TableCell style={{ textAlign: "center" }} className={classes.text}>
            <Typography variant="h6"> Car/Trl Number: </Typography>
            {record.outboundShipment.railCarNumber} <br />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

const LineItemsBlock = ({ record, ...props }) => {
  const classes = useStyles();

  return (
    <Grid container fullwidth spacing={3}>
      <Grid item xs={12} align="center">
        {" "}
        <Divider />{" "}
      </Grid>
      <Grid item xs={12}>
        {" "}
        <Typography variant="h6"> Outbound Inventory: </Typography>{" "}
      </Grid>
      <Grid item xs={12}>
        <Table
          id="outboundInventory"
          key="outboundInventory"
          style={{ width: "100%" }}
        >
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={2}
                style={{ textAlign: "left" }}
                className={classes.text}
              >
                <Typography variant="overline"> Product Code </Typography>
              </TableCell>
              <TableCell style={{ textAlign: "left" }} className={classes.text}>
                <Typography variant="overline"> Product Name </Typography>
              </TableCell>
              <TableCell style={{ textAlign: "left" }} className={classes.text}>
                <Typography variant="overline"> Lot Number </Typography>
              </TableCell>
              <TableCell
                style={{ textAlign: "right" }}
                className={classes.text}
              >
                <Typography variant="overline"> Quantity </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(record?.outboundShipment?.shipmentLineItems?.items ?? []).map(
              (lineItem) => (
                <TableRow>
                  <TableCell
                    colSpan={2}
                    style={{ textAlign: "left" }}
                    className={classes.text}
                  >
                    <TextField
                      source="inventory.productCode"
                      label="Product Code"
                      record={lineItem}
                    />
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "left" }}
                    className={classes.text}
                  >
                    <TextField
                      source="inventory.productName"
                      label="Product Name"
                      record={lineItem}
                    />
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "left" }}
                    className={classes.text}
                  >
                    <TextField
                      source="inventory.lotNumber"
                      label="Lot Number"
                      record={lineItem}
                    />
                  </TableCell>
                  <TableCell
                    style={{ textAlign: "right" }}
                    className={classes.text}
                  >
                    <NumberField
                      source="totalQuantityToPick"
                      label="Quantity"
                      record={lineItem}
                    />
                  </TableCell>
                </TableRow>
              ),
            )}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

const InvoiceShowOutboundBlock = ({ record, ...props }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      fullwidth
      spacing={3}
      alignItems="center"
      justifyContent="center"
      className={classes.root}
    >
      <Grid item xs={12} align="center">
        <HeaderBlock {...props} />
        <InfoBlock record={record} {...props} />
        <LineItemsBlock record={record} {...props} />
      </Grid>
    </Grid>
  );
};

export default InvoiceShowOutboundBlock;
